<template>
  <div class="relative">
    <span class="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm text-muted-foreground">$</span>
    <Input v-bind="$attrs" v-model="model" type="text" inputmode="numeric" class="!pl-6" @beforeinput="onBeforeInput" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { Input } from '@/components/ui/input';

defineOptions({ inheritAttrs: false });

const props = defineProps<{ modelValue: number | undefined }>();

const emit = defineEmits<{
  'update:modelValue': [value: number | undefined];
}>();

const model = computed({
  get: () => props.modelValue ?? '',
  set: (value: string | number) => {
    const digits = String(value).replace(/\D/g, '');
    emit('update:modelValue', digits === '' ? undefined : Number(digits));
  },
});

const onBeforeInput = (e: InputEvent) => {
  if (e.data !== null && !/^\d+$/.test(e.data)) {
    e.preventDefault();
  }
};
</script>
